/* unplugin-vue-components disabled */import { render } from "./advantageCom.vue?vue&type=template&id=2e554da1&scoped=true"
import script from "./advantageCom.vue?vue&type=script&lang=js"
export * from "./advantageCom.vue?vue&type=script&lang=js"

import "./advantageCom.vue?vue&type=style&index=0&id=2e554da1&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/.pnpm/vue-loader@17.4.2_vue@3.4.15_webpack@5.89.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e554da1"]])

export default __exports__